<script setup lang="ts">
const telegramGroupUrl = 'https://t.me/descontito_ofertas'
const xProfileUrl = 'https://x.com/meudescontito'
const { trackEvent } = useUmami()

function trackSocialClick(channel: 'telegram' | 'x') {
  trackEvent('footer-social-click', { channel })
}
</script>

<template>
  <footer class="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 mt-12">
    <div class="container mx-auto px-4 py-8">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <h3 class="font-bold text-gray-900 dark:text-white mb-3">Descontito</h3>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            As melhores ofertas e cupons de desconto do Brasil.
          </p>
        </div>
        <div>
          <h3 class="font-semibold text-gray-900 dark:text-white mb-3">Navegar</h3>
          <ul class="space-y-2 text-sm text-gray-600 dark:text-gray-400">
            <li><NuxtLink to="/" class="hover:text-primary-500">Ofertas</NuxtLink></li>
            <li><NuxtLink to="/cupons" class="hover:text-primary-500">Cupons</NuxtLink></li>
            <li><NuxtLink to="/busca" class="hover:text-primary-500">Busca</NuxtLink></li>
          </ul>
        </div>
        <div>
          <h3 class="font-semibold text-gray-900 dark:text-white mb-3">Conta</h3>
          <ul class="space-y-2 text-sm text-gray-600 dark:text-gray-400">
            <li><NuxtLink to="/login" class="hover:text-primary-500">Entrar</NuxtLink></li>
            <li><NuxtLink to="/registro" class="hover:text-primary-500">Cadastrar</NuxtLink></li>
            <li><NuxtLink to="/minha-conta/favoritos" class="hover:text-primary-500">Favoritos</NuxtLink></li>
          </ul>
        </div>
        <div>
          <h3 class="font-semibold text-gray-900 dark:text-white mb-3">Social</h3>
          <ul class="space-y-2 text-sm text-gray-600 dark:text-gray-400">
            <li>
              <a
                :href="telegramGroupUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="hover:text-primary-500"
                @click="trackSocialClick('telegram')"
              >
                Telegram
              </a>
            </li>
            <li>
              <a
                :href="xProfileUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="hover:text-primary-500"
                @click="trackSocialClick('x')"
              >
                X / Twitter
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700 text-center text-sm text-gray-500 dark:text-gray-400">
        <p>© {{ new Date().getFullYear() }} Descontito. Todos os direitos reservados.</p>
        <p class="mt-1 text-xs">
          Os preços e disponibilidade das ofertas podem sofrer alterações. Confirme sempre no site da loja.
        </p>
      </div>
    </div>
  </footer>
</template>
